import modal from '@/utils/modal';
import eventbus from '@/utils/eventbus';
import getMerchantConfig from '@/utils/getMerchantConfig';
import getSlotData from './getSlotData';

import state from '@/state';

async function createAvatarConfigurator (cfg) {
  let config = cfg;
  let rootEl = null;

  const t = state.t.prefix('avatar');

  let cfgData = {
    selectedSlot: null,
    partGroupMap: {},
    selectedPartsMap: {},
    partMap: {},
    elements: {
      slots: {},
    },
  };

  function setPartCollection (groups) {
    cfgData.partGroupMap = {};
    cfgData.selectedPartsMap = {};
    cfgData.partMap = {};

    for (const slot of groups) {
      cfgData.partGroupMap[slot.id] = slot;
      cfgData.selectedPartsMap[slot.id] = {
        part: null,
        paletteId: null,
        paletteColor: null,
      };
      for (const part of slot.availableParts) {
        cfgData.partMap[part.id] = part;
        if (part.isEquipped) {
          cfgData.selectedPartsMap[slot.id].part = part.id;
          cfgData.selectedPartsMap[slot.id].paletteId = part.selectedPaletteId;
          if (part.palettes) {
            for (const palette of part.palettes) {
              if (palette.id === cfgData.selectedPartsMap[slot.id].paletteId) {
                cfgData.selectedPartsMap[slot.id].paletteColor = palette.iconColor;
                break;
              }
            }
          }
        }
      }
    }
  }

  function updatePaletteSelector () {
    const picker = rootEl.querySelector('.gmf-ac-palette-picker');
    const parent = rootEl.querySelector('.gmf-ac-palettes');
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }

    const part = cfgData.partMap[cfgData.selectedPartsMap[cfgData.selectedSlot].part];
    const slot = cfgData.partGroupMap[cfgData.selectedSlot];

    if (part && !slot.hidePalettePicker && part.palettes && part.palettes.length > 0) {
      for (const palette of part.palettes) {
        const el = document.createElement('div');
        el.classList.add('gmf-ac-palette');

        if (cfgData.selectedPartsMap[cfgData.selectedSlot].paletteId === palette.id) {
          el.classList.add('gmf-active');
        }

        el.style.background = palette.iconColor;

        el.onclick = () => {
          equip(cfgData.selectedSlot, part.id, palette.id);
        }

        parent.appendChild(el);
      }
      picker.classList.remove('gmf-hidden');
    } else {
      picker.classList.add('gmf-hidden');
    }
  }

  function equip (slotId, partId, paletteId) {
    if (cfgData.selectedPartsMap[slotId].paletteId === paletteId && cfgData.selectedPartsMap[slotId].part === partId) {
      return; // Already equipped
    }

    rootEl.querySelectorAll('.gmf-ac-preview').forEach(function (el) {
      if ((el.dataset.part || null) === partId) {
        el.classList.add('gmf-active');
      }  else {
        el.classList.remove('gmf-active');
      }
    });

    const part = cfgData.partMap[partId];

    let newIconColor = null;
    if (part && part.palettes) {
      for (const palette of part.palettes) {
        if (palette.id === paletteId) {
          newIconColor = palette.iconColor;
          break;
        }
      }
    }

    cfgData.selectedPartsMap[slotId].paletteId = paletteId;
    cfgData.selectedPartsMap[slotId].part = partId;

    updatePaletteSelector();

    // @TODO error handler
    callApi('POST', '/v1/avatar/equip', {
      part: partId || null,
      slot: slotId,
      palette: paletteId,
    }).then(res => {
      if (res.status == 401) {
        handleEvent('session_expired') && modal.error(t('session_expired'));
        return;
      }
      res.json().then(data => {
        setAvatarUrl(data.avatarCode);
        eventbus.emit('avatar:update', data.avatarCode);

        state.profile.avatarUrl = `${state.cdnBase}/v1/avatar/render/${data.avatarCode}`;
        state.profile.avatarCode = data.avatarCode;
                
        let shouldUpdatePartsList = false;

        if (newIconColor !== cfgData.selectedPartsMap[slotId].paletteColor) {
          cfgData.selectedPartsMap[slotId].paletteColor = newIconColor;
          shouldUpdatePartsList = true;
        }

        if (data.alsoEquipped) {
          for (const row of data.alsoEquipped) {
            cfgData.selectedPartsMap[row.slotId].paletteId = row.paletteId || null;
            cfgData.selectedPartsMap[row.slotId].part = row.partId || null;
            cfgData.selectedPartsMap[row.slotId].paletteColor = row.paletteColor || null;
            if (row.slotId === cfgData.selectedSlot) {
              shouldUpdatePartsList = true;
            }
          }
        }

        if (shouldUpdatePartsList) {
          updatePartsList();
        }
      });
    });
  }

  function updatePartsList () {
    const rightCol = rootEl.querySelector('.gmf-ac-part-container');
    rightCol.innerHTML = '';

    const group = cfgData.partGroupMap[cfgData.selectedSlot];

    if (! group) {
      console.warn('Avatar part group "' + cfgData.selectedSlot + '" not found');
      return;
    }

    /*
    const titleEl = document.createElement('div');
    titleEl.classList.add('gmf-ac-slot-sel-group-title');
    titleEl.innerText = group.name;
    groupEl.appendChild(titleEl);
    */

    const partContainer = document.createElement('div');
    rightCol.appendChild(partContainer);

    if (! group.isRequired) {
      (() => {
        const partEl = document.createElement('div');
        partEl.classList.add('gmf-ac-preview');
        partEl.classList.add('gmf-ac-dequip');
        partEl.dataset.part = '';
        partEl.dataset.slot = group.id;

        partContainer.appendChild(partEl);
      })();
    }

    for (const part of group.availableParts) {
      const partEl = document.createElement('div');
      partEl.classList.add('gmf-ac-preview');
      if (cfgData.selectedPartsMap[group.id].part === part.id) {
        partEl.classList.add('gmf-active');
      }
      let base = state.cdnBase;//config.personalizedPreviews ? state.apiBase : state.cdnBase;

      let src = base+ '/v1/avatar/render/' + encodeURIComponent(part.previewCode);
      if (part.palettes) {
        for (const palette of part.palettes) {
          if (palette.iconColor === cfgData.selectedPartsMap[group.id].paletteColor) {
            src = base+ '/v1/avatar/render/' + encodeURIComponent(palette.previewCode);
            break;
          }
        }
      }
      partEl.style['background-image'] = 'url(' + src + ')';
      partEl.dataset.part = part.id;
      partEl.dataset.slot = group.id;

      if (part.isNew) {
        const newEl = document.createElement('div');
        newEl.classList.add('gmf-ac-new-indicator');
        partEl.appendChild(newEl);
      }

      partContainer.appendChild(partEl);
    }

    attachEquipHandlers();
  }

  function setAvatarUrl (avatarUrl) {
    rootEl.querySelectorAll('.gmf-ac-avatar').forEach(el => {
      el.src = state.cdnBase + '/v1/avatar/render/' + encodeURIComponent(avatarUrl);
    });
  }

  function attachEquipHandlers () {
    rootEl.querySelectorAll('.gmf-ac-preview').forEach(function(el) {
      el.onclick = function () {
        const slotId = el.dataset.slot;

        let palette = null;

        if (el.dataset.part) {
          const part = cfgData.partMap[el.dataset.part];
          if (cfgData.selectedPartsMap[slotId].paletteColor && part.palettes) {
            for (const p of part.palettes) {
              if (p.iconColor === cfgData.selectedPartsMap[slotId].paletteColor) {
                palette = p.id;
                break;
              }
            }
          }


          if (part.isNew) {
            part.isNew = false;

            const slot = cfgData.partGroupMap[el.dataset.slot];

            let stillHasNewPart = false;
            for (const part of slot.availableParts) {
              if (part.isNew) {
                stillHasNewPart = true;
                break;
              }
            }

            if (! stillHasNewPart) {
              cfgData.elements.slots[slot.id].innerHTML = '';
              slot.hasNewParts = false;
            }

            el.innerHTML = ''; // Removes the "new part" indicator
          }

        }

        /*
        if (ev.target.classList.contains('gmf-ac-palette-opt')) {
          palette = ev.target.dataset.palette;
        }gmf-ac-slot-sel-group
        */

        equip(slotId, el.dataset.part, palette);
      };
    });
  }

  function callApi (method, url, body) {
    const data = {
      mode: 'cors',
      headers: {
        'Authorization': 'Bearer ' + state.customerToken,
      },
      method,
    };

    if (body) {
      data.headers['Content-Type'] = 'application/json';
      data.body = JSON.stringify(body);
    }

    return fetch(state.apiBase + url, data);
  }

  function updateSlots (slots) {
    cfgData.elements.slots = {};
    const slotMap = {};

    for (const slot of slots) {
      slotMap[slot.id] = slot;
    }

    const container = rootEl.querySelector('.gmf-ac-slots');

    for (const slot of config.slots) {
      const el = document.createElement('div');
      el.classList.add('gmf-ac-slot-selector');
      el.dataset.slot = slot.id;
      el.onclick = function (ev) {
        if (config.personalizedPreviews) {
          selectAndLoadSlot(ev.target.dataset.slot);
        } else {
          selectSlot(ev.target.dataset.slot);
        }
      }
      el.style['background-image'] = 'url(' + slot.icon + ')';
      if (slotMap[slot.id] && slotMap[slot.id].hasNewParts) {
        const newEl = document.createElement('div');
        newEl.classList.add('gmf-ac-new-indicator');
        el.appendChild(newEl);
      }
      container.appendChild(el);
      cfgData.elements.slots[slot.id] = el;
    }
  }

  function selectSlot (slotId) {
    if (! slotId) {
      console.log('Tried to select invalid avatar slot id', slotId);
      return;
    }
    cfgData.selectedSlot = slotId;
    for (const el of rootEl.querySelectorAll('.gmf-ac-slot-selector')) {
      if (el.dataset.slot === slotId) {
        el.classList.add('gmf-active');
      } else {
        el.classList.remove('gmf-active');
      }
    }

    updatePartsList();
    updatePaletteSelector();
  }

  function handleEvent (eventName) {
    if (config.on && config.on[eventName]) {
      return config.on[eventName]();
    }
    return true;
  }

  async function selectAndLoadSlot (slotId) {
    let url = '/v1/avatar/configurator-data';

    if (config.personalizedPreviews) {
      url += '?slot_id=' + slotId;
      url += '&personalized_previews';
    }

    const res = await callApi('GET', url)
    if (res.status !== 200) {
      handleEvent('session_expired') && modal.error(t('session_expired'));
      return;
    }
    const data = await res.json();

    setPartCollection(data.avatarSlots);
    selectSlot(slotId);
  }

  async function loadAvatarConfigurator () {
    let url = '/v1/avatar/configurator-data';

    if (config.personalizedPreviews) {
      url += '?slot_id=' + config.slots[0].id;
      url += '&personalized_previews';
    }

    const res = await callApi('GET', url)
    if (res.status !== 200) {
      handleEvent('session_expired') && modal.error(t('session_expired'));
      return;
    }
    const data = await res.json()

    setAvatarUrl(data.avatarUrl);
    updateSlots(data.avatarSlots);
    setPartCollection(data.avatarSlots);
    selectSlot(config.slots[0].id);
  }

  let resizeObserver;

  const mc = await getMerchantConfig();

  const slotData = await getSlotData();
  if (! config.slots) {
    config.slots = slotData.slots;
    if (mc.avatarConfigurator.slots && mc.avatarConfigurator.slots.length) {
      config.slots = mc.avatarConfigurator.slots;
    }
  }

  if (! ('personalizedPreviews' in config)) {
    config.personalizedPreviews = mc.avatarConfigurator.personalizedPreviews;
  }

  cfgData.selectedSlot = config.slots[0].id;

  rootEl = (cfg.selector instanceof Element) ? cfg.selector : document.querySelector(cfg.selector);

  if (! rootEl) {
    console.error('Invalid avatar configurator selector (' + cfg.selector + ')');
    return;
  }

  rootEl.innerHTML += `
  <div class="gmf-ac-container">

    <div class="gmf-ac-head"><div class="gmf-ac-avatar-wrapper"><img class="gmf-ac-avatar" /></div><div class="gmf-ac-slots"></div><div style="clear: both;"></div></div>

    <div class="gmf-ac-part-container"></div>

    <div class="gmf-ac-palette-picker gmf-hidden">
      <div class="gmf-text-small gmf-mb-1">${t('pick_color')}</div>
      <div class="gmf-ac-palettes">
      </div>
    </div>
  </div>`;

  loadAvatarConfigurator();

  cfg.followHeader = false; // Disabling sticky header forever, so we dont need following atm
  if (cfg.followHeader) {
    // @TODO remove this handler on destroy...
    const followHeader = document.querySelector(cfg.followHeader);
    if (followHeader) {
      setTimeout(() => {
        const head = document.querySelector('.gmf-ac-head');

        head.style.top = followHeader.clientHeight + 'px';

        function updateTop (elements) {
          const height = elements[0].target.clientHeight;
          head.style.top = height + 'px';
        }
        resizeObserver = new ResizeObserver(updateTop);
        resizeObserver.observe(followHeader);

      }, 1);
    } else {
      console.error('Invalid header selector', cfg.followHeader);
    }
  }

  return {
    destroy () {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    },
  };
}

export {createAvatarConfigurator};
